import React from 'react';

import { styled } from '@mui/material/styles';
import { css } from '@emotion/css';
import FaIconUvilo from '../components/FaIconUvilo';
import { MaterialDesignContent, type SnackbarProviderProps } from 'notistack';

const SnackContainerClass = css`
  top: env(safe-area-inset-top) !important;
  left: auto !important;
  right: 136px !important;
  transform: none !important;

  @media (max-width: 599.95px) {
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
`;

const SnackStyledContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent > div:first-of-type': {
    maxWidth: 400,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  '&.notistack-MuiContent': {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: 0,
    },
  },
  '&.notistack-MuiContent-success, &.notistack-MuiContent-warning, &.notistack-MuiContent-info': {
    backgroundColor: 'rgba(58, 58, 58, 0.3)',
    backdropFilter: theme.palette.background.filter,
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
    borderRight: '1px solid rgba(0, 0, 0, 0.25)',
    boxShadow: 'none',
  },
}));

const SnackComponents = {
  default: SnackStyledContent,
  success: SnackStyledContent,
  error: SnackStyledContent,
  warning: SnackStyledContent,
  info: SnackStyledContent,
};

export const snackProviderProps: SnackbarProviderProps = {
  Components: SnackComponents,
  classes: {
    containerRoot: SnackContainerClass,
  },
  maxSnack: 1,
  iconVariant: {
    success: <FaIconUvilo icon="circle-check" size="xl" sx={{ color: 'success.main', mr: 4 }} />,
    error: <FaIconUvilo icon="circle-xmark" size="xl" sx={{ mr: 4 }} />,
    warning: (
      <FaIconUvilo icon="triangle-exclamation" size="xl" sx={{ color: 'warning.main', mr: 4 }} />
    ),
    info: <FaIconUvilo icon="circle-info" size="xl" sx={{ color: 'info.main', mr: 4 }} />,
  },
};
